import { IFilterTag } from "src/api/server/extended-search.types";
import { IChangeFilterTag } from "src/components/pages/search/components/types";
import { useSearchStore } from "src/components/pages/search/store/search-store";
import { EnumTagColor } from "src/types/common-enum";
import { FilterTagCheckbox } from "./filter-tag-checkbox/filter-tag-checkbox";

export interface ICheckboxList {
    filterTags: IFilterTag[];
    color: EnumTagColor;
    onChange: (changeFilterTag: IChangeFilterTag) => void;
}

export const CheckboxList = ({ filterTags, color, onChange }: ICheckboxList) => {
    const { tags: selectedTags } = useSearchStore();

    const isTagChecked = (tag: IFilterTag) => selectedTags.some(selectedTag => selectedTag.value === tag.urlIdentifier);

    return (
        <>
            {filterTags.map((tag: IFilterTag) => (
                <FilterTagCheckbox
                    key={tag.urlIdentifier}
                    color={color}
                    label={tag.label}
                    checked={isTagChecked(tag)}
                    onChange={event =>
                        onChange({
                            isChecked: event.target.checked,
                            value: tag.urlIdentifier as string,
                            isPopular: tag.isPopular,
                        })
                    }
                />
            ))}
        </>
    );
};
